<script setup>
import { useSettingsStore } from "~/stores/settings";

const settingsStore = useSettingsStore();
const settings = settingsStore.settings;
</script>

<template>
  <BaseOverflowShadow :hidden-shadow="790">
    <template #list>
      <div
        class="scrollbar-hide flex min-w-full  justify-start gap-5 overflow-x-auto overflow-y-hidden px-4 lg:px-0 relative"
      >
        <template v-for="(menu, index) in settings.general_menu_start" :key="`${menu.title}-${index}`">
          <NuxtLink :to="menu.link">
            <div
              class="flex flex-col items-center space-y-1 text-center hover:opacity-80"
            >
              <div
                class="flex h-14 w-14 items-center justify-center rounded-full bg-darken-brand-primary xl:mb-2 xl:h-16 xl:w-16"
              >
                <Icon :name="menu.icon" size="32" class="text-brand-primary" />
              </div>

              <p class="text-xs font-medium leading-none text-gray-300">
                {{ menu.title.split(" ")[0] }}<br />
                <small>
                  <template v-for="word in menu.title.split(' ').slice(1)">
                    {{ word.concat(" ") }}
                  </template>
                </small>
              </p>
            </div>
          </NuxtLink>
        </template>
      </div>
    </template>
  </BaseOverflowShadow>
  <!-- Loader -->
  <PageLoadersCircleLoaders v-if="false" />
</template>